import { computed as f, resolveComponent as x, createBlock as i, createCommentVNode as k, openBlock as o, unref as n, withCtx as r, createElementBlock as g, createVNode as s, Fragment as _, renderList as y, createElementVNode as h, createTextVNode as d, toDisplayString as l } from "vue";
import { BNavItemDropdown as N, BDropdownItem as b, BDropdownDivider as w } from "bootstrap-vue-next";
import { g as C } from "../lib/getAppUrl.zOygEGj2.js";
const B = ["aria-label"], M = {
  class: "me-1 rounded-pill badge text-bg-danger",
  role: "status"
}, V = {
  __name: "NavUnreadMessages",
  props: {
    unreadMessages: {
      type: Array,
      default: () => []
    }
  },
  setup(v) {
    const u = v, c = f(() => {
      let e = 0;
      for (const t of u.unreadMessages)
        e += t.unreadCount;
      return e == 0 ? "" : `${e}`;
    }), p = f(() => {
      let e = 0;
      for (const t of u.unreadMessages)
        t.unreadCount > 0 && (e += 1);
      return e;
    });
    return (e, t) => {
      const m = x("font-awesome-icon");
      return c.value !== "" ? (o(), i(n(N), {
        key: 0,
        right: "",
        "no-caret": ""
      }, {
        "button-content": r(() => [
          h("span", {
            class: "me-1 rounded-pill badge text-bg-danger",
            role: "status",
            "aria-label": `${c.value} unread chat messages`
          }, [
            d(l(c.value) + " ", 1),
            p.value > 1 ? (o(), g(_, { key: 0 }, [
              s(m, { icon: "comment" }),
              d(" x" + l(p.value), 1)
            ], 64)) : (o(), i(m, {
              key: 1,
              icon: "comment"
            }))
          ], 8, B)
        ]),
        default: r(() => [
          (o(!0), g(_, null, y(u.unreadMessages, (a) => (o(), i(n(b), {
            key: a.channelId,
            href: `${n(C)("chat")}/c/${a.channelId}`,
            "aria-label": `${a.unreadCount} ${a.channelName}`,
            "data-dd-privacy": "mask"
          }, {
            default: r(() => [
              h("span", M, l(a.unreadCount), 1),
              d(" " + l(a.channelName), 1)
            ]),
            _: 2
          }, 1032, ["href", "aria-label"]))), 128)),
          s(n(w)),
          s(n(b), {
            href: n(C)("chat")
          }, {
            default: r(() => [
              s(m, {
                "fixed-width": "",
                icon: "comment"
              }),
              t[0] || (t[0] = d(" Chat "))
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        _: 1
      })) : k("", !0);
    };
  }
};
export {
  V as _
};
